/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * CR022 Autodesk Vault - CAD Download Basket
 *
 *==================================================
 */
import { RootReducerState } from "../reducers";

const cadBasketSelector = (state: RootReducerState) => {
    return state.cadBasket;
}

const cadBasketItemsSelector = (state: RootReducerState) => {
    return state.cadBasket?.items ?? [];
}

const cadBasketNumItemsSelector = (state: RootReducerState) => {
    return state.cadBasket?.items?.length ?? 0;
}

const cadBasketIsLoadingSelector = (state: RootReducerState) => {
    return state.cadBasket?.isLoading || false;
}

const cadBasketZipRequestedSelector = (state: RootReducerState) => {
    return state.cadBasket?.zipRequested || false;
}

const cadPdpExclusionsSelector = (state: RootReducerState) => {
    return state.cadBasket?.pdpExclusions ?? { partNumber: null, ids: [] };
}

export {
    cadBasketSelector,
    cadBasketItemsSelector,
    cadBasketNumItemsSelector,
    cadBasketIsLoadingSelector,
    cadBasketZipRequestedSelector,
    cadPdpExclusionsSelector,
}
